<template>
  <div>
    <v-dialog v-model="show" max-width="80vh" scrollable>
      <v-card>
        <v-card-title>
          Key Performance Indicators - Selectors
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            class="mr-4"
          ></v-text-field>
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="py-3">
          <v-data-table
            :headers="tableHeaders"
            :items="selectors"
            :items-per-page="10"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, -1]
            }"
          >
            <template v-slot:[`item.Selector_Name`]="{ item }">
              <v-text-field
                v-if="editMode && currentItem && currentItem.KPI_Selector_ID === item.KPI_Selector_ID"
                v-model="currentItem.Selector_Name"
                dense
                label="Selector Name"
              ></v-text-field>
              <span v-else>{{ item.Selector_Name }}</span>
            </template>

            <template v-slot:[`item.KPI_Type`]="{ item }">
              <v-select
                v-if="editMode && currentItem && currentItem.KPI_Selector_ID === item.KPI_Selector_ID"
                v-model="currentItem.KPI_Type_ID"
                :items="kpiTypes"
                item-text="KPI_Type"
                item-value="KPI_Type_ID"
                dense
                label="Select KPI Type"
              ></v-select>
              <span v-else>{{ item.KPI_Type }}</span>
            </template>

            <template v-slot:[`item.Actions`]="{ item }">
              <v-btn
                :disabled="editMode && (currentItem.KPI_Selector_ID !== item.KPI_Selector_ID) || (currentItem && currentItem.KPI_Selector_ID === item.KPI_Selector_ID && canUpdate)"
                :color="editMode && currentItem.KPI_Selector_ID === item.KPI_Selector_ID ? 'success' : 'primary'"
                small
                icon
                @click="onEditClick(item)"
              >
                <v-icon>
                  {{ editMode && currentItem.KPI_Selector_ID === item.KPI_Selector_ID ? 'mdi-check-circle' : 'mdi-pencil-circle' }}
                </v-icon>
              </v-btn>

<!--This feature is currently disabled.-->
<!--               <v-btn
                small
                icon
                color="red darken-2"
                v-if="index !== currentRowIndex"
                :disabled="editMode"
                @click="onDeleteClick(item)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
 -->
              <v-btn
                small
                icon
                color="red darken-2"
                v-if="!editMode || (currentItem && currentItem.KPI_Selector_ID !== item.KPI_Selector_ID)"
                :disabled="true"
                @click="onDeleteClick(item)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>

              <v-btn
                v-if="editMode && currentItem && currentItem.KPI_Selector_ID === item.KPI_Selector_ID"
                color="primary"
                small
                icon
                @click="onCancelClick"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            small
            :disabled="editMode"
            @click="createNewDialog = !createNewDialog"
          >
            Add New
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500" v-model="createNewDialog">
      <v-card>
        <v-card-title>
          New KPI Selector
          <v-spacer></v-spacer>
          <v-btn icon @click="createNewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pa-4">
          <v-text-field
            label="Selector Name"
            v-model="newSelectorName"
            dense
          ></v-text-field>
          <v-select
            label="KPI Type"
            v-model="newSelectorType"
            :items="kpiTypes"
            item-text="KPI_Type"
            item-value="KPI_Type_ID"
            dense
          ></v-select>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :disabled="!newSelectorName || !newSelectorType" @click="createSelector">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmOrDeniedDialog
      v-if="deleteDialog"
      v-model="deleteDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteSelector"
      @onCancelClick="cancelDelete"
    />
  </div>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'KeyPerformanceIndicator',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: { type: Boolean, default: false }
  },
  data () {
    return {
      search: '',
      currentItem: null,
      selectors: [],
      kpiTypes: [],
      newSelectorName: '',
      newSelectorType: null,
      createNewDialog: false,
      deleteDialog: false,
      editMode: false,
      tableHeaders: [
        { text: 'Selector Name', value: 'Selector_Name', class: 'px-2 text-no-wrap', cellClass: 'px-2 text-no-wrap' },
        { text: 'KPI Type', value: 'KPI_Type', class: 'px-2 text-no-wrap', cellClass: 'px-2 text-no-wrap' },
        { text: 'Actions', value: 'Actions', align: 'center', sortable: false, width: 120 }
      ]
    }
  },
  computed: {
    user () { return this.$store.getters.getUser },
    show: {
      get () { return this.value },
      set (v) { this.$emit('input', v) }
    },
    canUpdate () {
      return !this.currentItem || !this.currentItem.Selector_Name || !this.currentItem.KPI_Type_ID
    },
    confirmOrDeniedDialogModes () { return this.$store.getters.getConfirmOrDeniedDialogModes }
  },
  mounted () {
    this.getKpiTypes().then(() => {
      this.getSelectors()
    })
  },
  methods: {
    async getSelectors (kpiTypeId = null) {
      try {
        const params = {}
        if (kpiTypeId !== null) {
          params.KPI_Type_ID = kpiTypeId
        }
        const res = await this.axios.get('/api/kpi_selectors', {
          params,
          headers: { Authorization: 'Bearer ' + this.user.token }
        })
        this.selectors = res.data
        await this.enrichSelectorsWithTypeIds()
      } catch (err) {
        const errorMsg = getApiErrorMessage(err)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    async getKpiTypes () {
      try {
        const res = await this.axios.get('/api/kpi_types', {
          headers: { Authorization: 'Bearer ' + this.user.token }
        })
        this.kpiTypes = res.data
      } catch (err) {
        const errorMsg = getApiErrorMessage(err)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    enrichSelectorsWithTypeIds () {
      this.selectors = this.selectors.map(selector => {
        const kpiType = this.kpiTypes.find(type => type.KPI_Type === selector.KPI_Type)
        return {
          ...selector,
          KPI_Type_ID: kpiType ? kpiType.KPI_Type_ID : null
        }
      })
    },
    onEditClick (item) {
      if (this.editMode) {
        this.updateSelector()
      } else {
        this.currentItem = Object.assign({}, item)
        this.editMode = true
      }
    },
    onCancelClick () {
      this.editMode = false
      this.currentItem = null
    },
    onDeleteClick (item) {
      this.deleteDialog = true
      this.currentItem = Object.assign({}, item)
    },
    cancelDelete () {
      this.deleteDialog = false
      this.currentItem = null
    },
    createSelector () {
      this.axios.post('/api/kpi_selector', {
        Selector_Name: this.newSelectorName,
        KPI_Type_ID: this.newSelectorType
      }, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(() => {
        this.createNewDialog = false
        this.newSelectorName = ''
        this.newSelectorType = null
        this.getSelectors()
        this.$store.dispatch('setSuccess', { successMsg: 'New KPI Selector created' })
      }).catch(err => {
        const errorMsg = getApiErrorMessage(err)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateSelector () {
      this.axios.put(`/api/kpi_selector/${this.currentItem.KPI_Selector_ID}`, {
        Selector_Name: this.currentItem.Selector_Name,
        KPI_Type_ID: this.currentItem.KPI_Type_ID
      }, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(() => {
        this.getSelectors()
        this.onCancelClick()
        this.$store.dispatch('setSuccess', { successMsg: 'KPI Selector updated' })
      }).catch(err => {
        const errorMsg = getApiErrorMessage(err)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    deleteSelector () {
      this.axios.delete(`/api/kpi_selector/${this.currentItem.KPI_Selector_ID}`, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(() => {
        this.cancelDelete()
        this.getSelectors()
        this.$store.dispatch('setSuccess', { successMsg: 'KPI Selector deleted' })
      }).catch(err => {
        const errorMsg = getApiErrorMessage(err)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
